module.exports = __webpack_public_path__ + "img/logo-participagoias.782c6825.svg";